<template lang="html">
  <div class="hwforget" v-loading="pageLoading">
    <div class="head">{{ $t('nav.mmp') }}</div>
    <template v-if="hasSetEmail">
    <div class="tip">
      <p v-if="isNext">{{ isfromPassSetting ? $t('overseaForget.enterFullEmail') : $t('overseaForget.enterAccount')}}</p>
      <p v-else>{{ $t('overseaForget.text1') }}<span>{{ emailAddr }}</span>,{{ $t('overseaForget.text2') }}</p>
      <p v-if="isNext && hiddenEmailAddr"><span>{{ hiddenEmailAddr }}</span></p>
    </div>
    <el-form :model='form' :rules='formrules' ref="form">
      <!-- next -->
      <!-- email -->
      <el-form-item :label="$t('overseaForget.loginAccount')" prop="useraccount" v-if="isNext && !isfromPassSetting">
        <el-input v-model="form.useraccount" @blur="getEmail()" @keyup.native="clearEmail"></el-input>
      </el-form-item>
      <el-form-item :label="$t('overseaForget.emailAddr')" prop="email" v-if="isNext">
        <el-input v-model="form.email" id="email" :disabled="!isfromPassSetting"></el-input>
        <span class="del" v-if="isErr">+</span>
      </el-form-item>
      <!-- Confirm -->
      <!-- 验证码 -->
      <el-form-item :label="$t('overseaForget.code')" prop="vCode" v-if="!isNext">
        <el-input v-model="form.vCode" auto-complete="new-password"></el-input>
        <span class="del" v-if="isErr2">+</span>
        <p class="count" v-if="resend">{{ $t('overseaForget.secend1') + countDown + $t('overseaForget.secend2') }}</p>
        <p class="count resend" v-if="!resend" @click="resendCode()">{{ $t('overseaForget.resend') }}</p>
      </el-form-item>
       <!-- 新密码 -->
      <el-form-item :label="$t('overseaForget.newPwd')" v-if="!isNext && !isfromPassSetting" prop="newPassword">
        <el-input type="password" v-model="form.newPassword" auto-complete="new-password"></el-input>
      </el-form-item>
      <!-- 新密码v-else -->
      <el-form-item :label="$t('overseaForget.newManagementPassword')" v-if="!isNext && isfromPassSetting" prop="msgPass">
        <el-input v-model="form.msgPass" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('overseaForget.confirmManagementPassword')" v-if="!isNext && isfromPassSetting" prop="rePass">
        <el-input v-model.trim="form.rePass" auto-complete="new-password" type="password"></el-input>
      </el-form-item>

      <div class="panel-header-btn panel-header-btn__fill" @click="handleNext()" v-if="isNext">
        <span class="el-icon-loading" v-if="loading"></span>
        <span>{{$t('overseaForget.next')}}</span>
      </div>
      <div class="panel-header-btn panel-header-btn__fill" @click="confirm('form')" v-else>
        <span class="el-icon-loading" v-if="loading"></span>
        <span v-else>{{$t('overseaForget.confirm') }}</span>
      </div>

    </el-form>
    </template>
    <div v-else class="no_email">
      <p>{{ $t('overseaForget.msg.m1' )}}</p>
      <p>{{ $t('overseaForget.msg.m2') }}</p>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import config from 'config';
import qs from 'qs';

export default {
  data() {
    // 邮箱验证
    let emailValid = (rul, val, cb) => {
      if (val === '') {
        cb(this.$t('overseaForget.enterEmail'))
      } else if(!/^[\w-]+[\w-.]*@[a-zA-Z\d-]+(\.[a-zA-Z\d-]+)*\.[a-zA-Z\d]{2,6}$/.test(val)) {
        // 不满足邮箱的格式，出现错误提示信息
        this.isErr = true;
        cb(this.$t('overseaForget.invalidEmail'));
      }else{
        this.isErr = false;
        cb();
      }
    };
    // 验证码验证
    let vCodeValid = (rul, val, cb) => {
      if( val === '') {
        cb(this.$t('overseaForget.filledCode'))
      } else {
        let param = {
          email: this.form.email,
          code: val,
          format: 'cors'
        }
        this.checkCode(param, (data) => {
          if(data.respcd === config.code.OK) {
            this.isErr2 = false;
            cb();
          }else{
            this.isErr2 = true;
            cb(data.respmsg);
          }
        });
      }
    };
    //  密码
    let passValid = (rul, val, cb) => {
      if( val === '') {
        cb(this.$t('shopmng.dialog.msg.m1'));
      } else {
        cb();
      }
    }
    let pass1Valid = (rule, val, cb) => {
      if(this.form.rePass !== '') {
        this.$refs['form'].validateField('rePass');
      }
      cb();
    };
    let repass1Valid = (rule, val, cb) => {
      if(this.form.msgPass && val !== this.form.msgPass) {
        cb(this.$t('passSet.msg.m9'));
      } else {
        cb();
      }
    };
    return {
      isNext: true,
      isfromPassSetting: false,
      hasSetEmail: true,
      loading: false,
      isErr: false,
      isErr2: false,
      resend: true,
      emailAddr: '',
      hiddenEmailAddr: '', // 根据后端接口获取对应邮箱地址
      pageLoading: false,
      countDown: 0,
      nextStatus: false,
      nextForm: false,
      form: {
        useraccount: '',
        email: '',
        vCode: '',
        newPassword: '',
        msgPass: '',
        rePass: '',
      },
      formrules: {
        useraccount: [
          { required: true, message: this.$t('overseaForget.enterAccount'), trigger: 'blur' }
        ],
        email: [
          { validator: emailValid, trigger: 'blur' }
        ],
        vCode: [
          { validator: vCodeValid, trigger: 'blur' }
        ],
        newPassword: [
          { validator: passValid, trigger: 'blur' },
          { max: 20, min: 6, message: this.$t('overseaForget.char'), trigger: 'blur' }
        ],
        msgPass: [
          { required: true, message: this.$t('overseaForget.msg.m3'), trigger: 'blur' },
          { max: 20, min: 6, message: this.$t('passSet.msg.m4') },
          { validator: pass1Valid },
        ],
        rePass: [
          { required: true, message: this.$t('overseaForget.msg.m4'), trigger: 'blur' },
          { max: 20, min: 6, message: this.$t('passSet.msg.m4') },
          { validator: repass1Valid },
        ],
      }
    }
  },

  created () {
    this.getRouterSource()
  },
  methods: {
    // 获取路由来源
    getRouterSource () {
      this.$route.query.source && this.$route.query.source === 'passsetting' ? this.isfromPassSetting = true : this.isfromPassSetting = false
      if (this.isfromPassSetting) {
        this.getEmailDirectly()
      }
    },
    // 直接获取邮箱地址
    getEmailDirectly () {
      this.pageLoading = true
      axios.get(`${config.host}/merchant/get/contactemail`, {
        params: {
          format: 'cors'
        }
      }).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.hiddenEmailAddr = data.data.contact_email || ''
          if (this.hiddenEmailAddr) {
            this.hasSetEmail = true
            let str = this.hiddenEmailAddr.slice(0, 1) + '******' + this.hiddenEmailAddr.slice(this.hiddenEmailAddr.indexOf('@') - 1)
            this.hiddenEmailAddr = str
          } else {
            this.hasSetEmail = false
          }
        } else {
          this.$message.error(data.respmsg)
        }
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    getEmail () {
      let param = {
        username: this.form.useraccount,
        format: 'cors'
      }
      if (this.form.useraccount === '') {
        return
      }
      axios.get(`${config.oHost}/mchnt/user/simple_info`, {
        params: param
      }).then((res) => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.form.email = data.data.contact_email
          this.nextForm = true
          if (this.nextStatus) {
            this.handleNext()
          }
        }else {
          this.nextStatus = false
          this.nextForm = false
          this.form.email = ''
          this.$message.error(data.respmsg)
        }
      }).catch(() => {
        this.$message.error(this.$t('common.netError'))
        this.nextStatus = false
        this.nextForm = false
      })
    },
    clearEmail () {
      this.form.email = ''
    },
    // 倒计时
    count() {
      this.resend = true;
      this.countDown = 60;
      var timer = setInterval(() => {
        this.countDown -= 1;
        // 小于0的时候关闭计时器
        if(this.countDown < 0) {
          clearInterval(timer);
          this.countDown = 60;
          this.resend = false;
        }
      }, 1000);
    },

    // 点击next按钮
    handleNext() {
      this.$refs['form'].validate((valid) => {
        if (this.form.email === '' && this.form.useraccount === '' && !this.isfromPassSetting) {
          this.nextStatus = false
          return
        } else if (this.form.useraccount !== '' || this.isfromPassSetting) {
          this.nextStatus = true
          if (valid && !this.loading) {
            if ((this.nextForm && this.form.email && !this.isfromPassSetting) || (this.form.email && this.isfromPassSetting)) {
              this.loading = true;
              // 向邮箱发送验证码
              this.sendCode();
              // 倒计时
              this.count();
            } else {
              this.nextStatus = false
            }
          } else {
            return false;
          }
        }
      });
    },

    // 点击再次发送验证码按钮
    resendCode() {
      this.loading = true;
      this.sendCode();
      this.count();
    },

    // 发送验证码
    sendCode() {
      let param
      param = {
        email: this.form.email,
        format: 'cors'
      };
      if (this.isfromPassSetting) {
        let userid = sessionStorage.getItem('account_user')
        param.userid = userid
      }
      axios.get(`${config.oHost}/mchnt/emailcode/send`, {
        params: param
      }).then((res) => {
        this.loading = false;
        // 发送成功
        if(res.data.respcd === config.code.OK) {
          // 切换出验证的表单
          this.isNext = false;
          // 隐藏@前的三位
          let arr = this.form.email.split("@");
          arr[0] = arr[0].substring(0, arr[0].length - 3) + "***";
          this.emailAddr = arr.join("@");
          this.$message({
            type: 'success',
            message: this.$t('overseaForget.codeResent')
          })
        } else {
          this.$message.error(res.data.respmsg);
        }
      }).catch(() => {
        this.$message.error(this.$t('common.netError'));
        this.loading = false;
      });
    },

    // 验证码验证
    checkCode(param, cb) {
      axios.post(`${config.oHost}/mchnt/smscode/check`, qs.stringify(param), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res) => {
        if(res.data.respcd === config.code.OK) {
          cb(res.data);
          this.isErr2 = false;
        } else {
          this.isErr2 = true;
          this.$message.error(res.data.respmsg)
        }
      }).catch(() => {
        this.$message.error(this.$t('common.netError'));
      });
    },

    // 提交
    confirm(formname) {
      this.$refs[formname].validate((valid) => {
        if(valid && !this.loading) {
          this.loading = true;
          let [url, param] = []
          if (this.isfromPassSetting) {
            url = `${config.host}/merchant/user/reset_manage_password`
            param = {
              isreset: true,
              new_password: this.form.msgPass,
              format: 'cors'
            }
          } else {
            url = `${config.oHost}/mchnt/user/reset_pwd`
            param = {
              username: this.form.email,
              code: this.form.vCode,
              password: this.form.newPassword,
              real_username: this.form.useraccount,
              format: 'cors'
            }
          }
          axios.post(url, qs.stringify(param), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res) => {
            if(res.data.respcd === config.code.OK) {
              this.$message({
                type: 'success',
                message: this.$t('common.modSucc')
              })
              if (this.isfromPassSetting) {
                setTimeout(() => {
                  this.loading = false;
                  this.$router.push('/main/passSetting')
                }, 2000)
              } else {
                // 跳转至登录页面
                setTimeout(() => {
                  this.loading = false;
                  this.$router.push('/login')
                }, 2000)
              }
            } else {
              this.loading = false;
              this.$message.error(res.data.respmsg);
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error(this.$t('common.netError'));
          });
        } else {
          this.$message.error(this.$t('common.modFailed'));
          return false;
        }

      })
    },
  }
}
</script>
<style lang="scss">
  .hwforget{
    height: 100%;
    background: url('./img/bg.png') no-repeat 20px bottom;
    .head {
      color: #FE9B20;
      font-size: 24px;
      text-align: center;
      padding: 30px 0;
      border-bottom: 2px solid #FE9B20;
    }
    .tip, .no_email{
      width:350px;
      margin: auto;
      padding: 100px 0 50px;
      font-size:18px;
      font-family:PingFangSC-Semibold;
      color:rgba(0,0,0,1);
      line-height:25px;
      span{
        color: #3878DE;
      }
    }
    .no_email {
      width: 272px;
      p {
        margin-bottom: 25px;
      }
    }
    .el-form {
      width: 350px;
      margin: auto;

      .el-form-item {
        margin-bottom: 20px;
        position: relative;
        .count {
          color: #9B9B9B;
          text-align: right;
        }
        .resend {
          color: #FE9B20;
          cursor: pointer;
        }
        .del{
          display:block;
          width: 20px;
          height:20px;
          border-radius:10px;
          position:absolute;
          background: red;
          top:34px;
          right:12px;
          text-align: center;
          line-height:15px;
          font-size:20px;
          font-weight:900;
          color:#fff;
          transform:rotate(45deg);
        }
      }
      .el-input__inner {
        width: 350px;
        height: 44px;
      }
      .el-form-item__label {
        font-size: 16px;
        padding: 0;
        text-align: left;
        line-height: 16px;
        color: #606470;
        margin-bottom: 5px;
      }
      .el-form-item__content {
        width: 100%;
        line-height: 1;
      }
      .panel-header-btn {
        padding:0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        margin-top: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// overseaforget.vue?9e69ade6